// app/hub/[bookmaker]/components/BookmakerHeader/PaymentStats.tsx

import type { FC } from 'react';
import { BitcoinIcon as Bitcoin } from '@/components/icons/BitcoinIcon';
import { DollarIcon as Dollar } from '@/components/icons/DollarIcon';

interface PaymentStatsProps {
  PaymentType: string;
  FreeSpins: string;
  isDesktop?: boolean;
}

export const PaymentStats: FC<PaymentStatsProps> = ({
  PaymentType,
  FreeSpins,
  isDesktop = false,
}) => {
  const innerContainerClass = isDesktop ? 'px-2' : 'px-4';

  return (
    <div className="max-w-[200px] lg:max-w-[150px]">
      <div className="flex flex-col gap-1">
        <div
          className={`flex flex-col justify-start ${innerContainerClass} gap-1 py-[6.5px] ${isDesktop ? 'h-[53px]' : ''}`}
        >
          <p className="font-normal text-gray text-xs leading-3">
            Payment types
          </p>
          <div className="flex flex-row gap-2">
            {PaymentType === 'All' && (
              <>
                <Dollar
                  desc="Fiat currency payment icon"
                  title="Fiat Currency"
                />
                <Bitcoin
                  desc="Bitcoin cryptocurrency payment icon"
                  title="Cryptocurrency"
                />
              </>
            )}
            {PaymentType === 'Crypto' && (
              <Bitcoin
                desc="Bitcoin cryptocurrency payment icon"
                title="Cryptocurrency"
              />
            )}
            {PaymentType !== 'All' && PaymentType !== 'Crypto' && (
              <Dollar desc="Fiat currency payment icon" title="Fiat Currency" />
            )}
          </div>
        </div>
        <div
          className={`flex flex-col justify-start ${innerContainerClass} gap-1 py-[6.5px] ${isDesktop ? 'h-[53px]' : ''}`}
        >
          <p className="font-normal text-gray text-xs leading-3">Free spins</p>
          <p
            className={`font-semibold text-base leading-[25px] ${isDesktop ? 'tracking-[0.01em]' : ''}`}
          >
            {FreeSpins}
          </p>
        </div>
      </div>
    </div>
  );
};
